/* eslint-disable no-param-reassign */
import packageInfo from '../../../package.json';
import {
  PLUGIN_NAME,
  LIST_TO_TARGET,
  SPEAKER_RELATION_FILTER,
  TAG_RELATION_FILTER,
  ID_FILTER_NAME,
  TOPIC_RELATION_FILTER
} from './constants';

const { version } = packageInfo;

async function load(app) {
  app.log.debug('loaded list-query-variables-plugin');

  app.events.on(
    'plugin:page-builder:list:query-variables:sync',
    async ({ data = {}, props = {} }) => {
      try {
        const { name } = props;
        const { sort, rawQueryStringified } = data;
        const mathchingList = LIST_TO_TARGET.find(list => name.includes(list));

        if (
          !mathchingList ||
          rawQueryStringified.includes('function_score') ||
          (sort && !sort.startsWith('_score'))
        ) {
          return;
        }

        const parsedRawQuery = JSON.parse(rawQueryStringified);

        // eslint-disable-next-line no-undef
        const queryShoulds = parsedRawQuery?.bool?.must[0]?.bool?.must[0]?.bool?.should || [];
        // eslint-disable-next-line no-undef
        const queryFilters = parsedRawQuery?.bool?.filter?.bool?.must[0]?.bool?.should || [];

        let alreadyProcessed = false;
        if (queryFilters.length) {
          queryFilters.forEach(filter => {
            const {
              bool: { should }
            } = filter;
            should.forEach(({ match = {} }) => {
              if (match[SPEAKER_RELATION_FILTER]) {
                if (typeof match[SPEAKER_RELATION_FILTER] === 'object') alreadyProcessed = true;
                match[SPEAKER_RELATION_FILTER] = {
                  boost: 30,
                  query: match[SPEAKER_RELATION_FILTER]
                };
              } else if (match[ID_FILTER_NAME]) {
                if (typeof match[ID_FILTER_NAME] === 'object') alreadyProcessed = true;
                match[ID_FILTER_NAME] = {
                  boost: 40,
                  query: match[ID_FILTER_NAME]
                };
              } else if (match[TAG_RELATION_FILTER]) {
                if (typeof match[TAG_RELATION_FILTER] === 'object') alreadyProcessed = true;
                match[TAG_RELATION_FILTER] = {
                  boost: 6,
                  query: match[TAG_RELATION_FILTER]
                };
              } else if (match[TOPIC_RELATION_FILTER]) {
                if (typeof match[TOPIC_RELATION_FILTER] === 'object') alreadyProcessed = true;
                match[TOPIC_RELATION_FILTER] = {
                  boost: 3,
                  query: match[TOPIC_RELATION_FILTER]
                };
              }
            });

            queryShoulds.push(...should);
          });
          queryFilters.length = 0;
        }

        if (alreadyProcessed) return;

        if (mathchingList === 'related-blog') {
          const updatedData = {
            function_score: {
              query: parsedRawQuery,
              functions: [
                {
                  field_value_factor: {
                    field: 'date',
                    modifier: 'sqrt',
                    factor: 1.2
                  }
                }
              ],
              boost_mode: 'multiply'
            }
          };
          data.rawQueryStringified = JSON.stringify(updatedData);
        } else {
          data.rawQueryStringified = JSON.stringify(parsedRawQuery);
        }
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log('search filter error', e);
      }
    }
  );

  return {
    name: PLUGIN_NAME,
    version
  };
}

load.pluginName = PLUGIN_NAME;

export default load;
